import snakeCaseKeys from "snakecase-keys";
import camelCaseKeys from "camelcase-keys";

export const snakeCaseObject = obj => snakeCaseKeys(obj);

export const camelCaseObject = obj => camelCaseKeys(obj);
